import { render, staticRenderFns } from "./SystemNavItemCreate.vue?vue&type=template&id=035e9a55&scoped=true"
import script from "./SystemNavItemCreate.vue?vue&type=script&lang=js"
export * from "./SystemNavItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e9a55",
  null
  
)

export default component.exports